const TRIGGERS = ['#'].join('');

export default TRIGGERS;
